import React from "react";
import { useTranslation } from "react-i18next";


const ContentDetail = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const { indicators, children } = props;
  return (
   
    <div id="downloadData" ref={ref} style={{ backgroundColor: "#fff", padding: "20px" }}>
      <div className="mb-5">
        <h5>{t("common:indicatorsDetail.IntroductionLinkage")}</h5>
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{
            __html:
              i18n.language === "th"
                ? indicators.importantSource
                : indicators.importantSourceEN || indicators.importantSource,
          }}
        />
      </div>
      <div className="mb-5">
        <h5>{t("common:indicatorsDetail.DefinitionMeaning")}</h5>
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{
            __html:
              i18n.language === "th"
                ? indicators.definition
                : indicators.definitionEN || indicators.definition,
          }}
        />
      </div>
      <div className="mb-5">
        <h5>{t("common:indicatorsDetail.KPIStructure")}</h5>
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{
            __html:
              i18n.language === "th"
                ? indicators.formularCalculate
                : indicators.formularCalculateEN ||
                  indicators.formularCalculate,
          }}
        />
      </div>

      {/* <div style={{ textAlign: "center" }}>
        <h5></h5>
        {indicators.link && indicators.link.includes("app.powerbi.com") && (
          <embed
            type="text/html"
            src={indicators.link}
            style={{ width: "100%", height: "650px" }}
          ></embed>
        )}
      </div> */}
      {children}
    </div>
  );
});
export default ContentDetail;
